export const endClientAreaPaths = {
	signIn: () => '/sign-in',
	signOut: () => '/sign-out',
	startApplication: () => '/',
	application: (applicationNodeId: number | ':applicationNodeId') => `/application/${applicationNodeId}`,
	applicationForm: (applicationNodeId: number | ':applicationNodeId', formName: string, formHash: string) =>
		`/application/${applicationNodeId}/form/${formName}/${formHash}`,
	applicationConnection: (applicationNodeId: number | ':applicationNodeId', applicationConnectionKind: string) =>
		`/application/${applicationNodeId}/${applicationConnectionKind}`,
	applicationSubmit: (applicationNodeId: number | ':applicationNodeId') => `/application/${applicationNodeId}/submit`,
	applicationSubmitted: () => '/application-submitted',
};
